import React from 'react';
import { Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import s from './CommentForAnonymous.scss';
const CommentForAnonymous = ()=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s.root
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "commentbox.anonymous.message",
        parent: "span"
    }, /*#__PURE__*/ React.createElement(BiLink, {
        href: Url.joinLink(),
        className: s.link,
        biData: {
            evid: BiEventType.REDIRECT_TO_LOGIN,
            referral_info: ReferralType.COMMENT
        }
    }, "Join the community"), ' to add your comment. Already a deviant? ', /*#__PURE__*/ React.createElement("a", {
        href: Url.loginLink(),
        className: s.link
    }, "Sign In")));
};
CommentForAnonymous.displayName = 'CommentForAnonymous';
export default CommentForAnonymous;
